import React from 'react';

const MayanLogo = ({ className = 'h-10' }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <img
        src="/assets/brand/mayan-logo.png"
        alt="MAYAN Technology"
        width={180}
        height={48}
        className="h-full w-auto object-contain"
      />
    </div>
  );
};

export default MayanLogo;
